module.exports = __webpack_public_path__ + "static/booklet-02@2x-91eb15144c265692ab3acb638e9edd4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/workshop/booklet-02@2x.png
// module id = 2728
// module chunks = 159849449761359